module.exports = "<p>payout-structure works!</p>\r\n"